/* @flow */
import AdminUpgradeCanadianOrganization from './AdminUpgradeCanadianOrganization';

export default AdminUpgradeCanadianOrganization;
